module.exports = __webpack_public_path__ + "img/gateway-yellow.1ebeb1df.png";